import React from 'react';
import { BackButton } from '../ui';
import DiceBackground from '../DiceBackground';
import { useTranslation } from '../../i18n';

interface SecurityProps {
  onBack: () => void;
}

export const Security: React.FC<SecurityProps> = ({ onBack }) => {
  const t = useTranslation();

  return (
    <div className="h-[100dvh] flex flex-col items-center justify-start text-white p-4 pt-8 relative select-none bg-[#1a101f] overflow-hidden">
      <DiceBackground count={10} />
      <BackButton onClick={onBack} />

      <h1 className="text-2xl lg:text-5xl font-bold tracking-tighter mb-6 text-theme drop-shadow-lg uppercase text-center relative z-10 mt-4">
        {t.security}
      </h1>

      <div className="w-full max-w-2xl flex-1 overflow-y-auto pr-2 custom-scrollbar relative z-10 flex flex-col gap-4 pb-8">

        {/* Bug Bounty Program */}
        <div className="pixel-card p-4 lg:p-6 border-l-4 border-l-red-400 bg-red-900/20">
          <h2 className="text-red-400 text-[10px] lg:text-sm mb-3 uppercase font-bold tracking-widest">
            {t.secBountyTitle}
          </h2>
          <div className="text-[8px] lg:text-xs leading-relaxed text-gray-300 flex flex-col gap-2">
            <p>{t.secBountyText}</p>
            <p>
              <strong className="text-white">{t.secReportTo}</strong>{' '}
              <span className="text-theme font-bold">me@rizasabuncu.com</span>
            </p>
          </div>
        </div>

        {/* Scope */}
        <div className="pixel-card p-4 lg:p-6 border-l-4 border-l-yellow-400 bg-yellow-900/20">
          <h2 className="text-yellow-400 text-[10px] lg:text-sm mb-3 uppercase font-bold tracking-widest">
            {t.secScopeTitle}
          </h2>
          <div className="text-[8px] lg:text-xs leading-relaxed text-gray-300 flex flex-col gap-2">
            <p>{t.secScopeIntro}</p>
            <div className="pixel-card bg-black/30 p-3 flex flex-col gap-1.5">
              <p className="text-white font-bold">
                *.dicepit.xyz <span className="text-green-400 text-[8px] lg:text-[9px]">{t.secInScope}</span>
              </p>
              <p className="text-gray-400">{t.secScopeApp}</p>
              {t.secScopeItems.map((item, i) => <p key={i}>- {item}</p>)}
            </div>
            <div className="pixel-card bg-black/30 p-3 flex flex-col gap-1.5 mt-1">
              <p className="text-gray-500 font-bold">
                {t.secOutOfScope}
              </p>
              {t.secOutItems.map((item, i) => <p key={i}>- {item}</p>)}
            </div>
          </div>
        </div>

        {/* Reward */}
        <div className="pixel-card p-4 lg:p-6 border-l-4 border-l-green-400 bg-green-900/20">
          <h2 className="text-green-400 text-[10px] lg:text-sm mb-3 uppercase font-bold tracking-widest">
            {t.secRewardTitle}
          </h2>
          <div className="text-[8px] lg:text-xs leading-relaxed text-gray-300 flex flex-col gap-2">
            <p>{t.secRewardIntro}</p>
            <div className="pixel-card bg-black/30 p-4 text-center">
              <div className="text-lg lg:text-3xl font-bold text-yellow-400 mb-1">
                1x
              </div>
              <div className="text-[10px] lg:text-base font-bold text-white uppercase tracking-wider">
                Kofteci Yusuf
              </div>
              <div className="text-[9px] lg:text-sm text-theme font-bold mt-0.5">
                200gr Et Doner
              </div>
              <p className="text-[8px] lg:text-[9px] text-gray-500 mt-2">
                {t.secRewardNote}
              </p>
            </div>
          </div>
        </div>

        {/* Rules */}
        <div className="pixel-card p-4 lg:p-6 border-l-4 border-l-blue-400 bg-blue-900/20">
          <h2 className="text-blue-400 text-[10px] lg:text-sm mb-3 uppercase font-bold tracking-widest">
            {t.secRulesTitle}
          </h2>
          <div className="text-[8px] lg:text-xs leading-relaxed text-gray-300 flex flex-col gap-2">
            {t.secRulesItems.map((item, i) => <p key={i}>- {item}</p>)}
          </div>
        </div>

        {/* Hall of Fame */}
        <div className="pixel-card p-4 lg:p-6 border-l-4 border-l-theme bg-purple-900/20">
          <h2 className="text-theme text-[10px] lg:text-sm mb-3 uppercase font-bold tracking-widest">
            {t.secFameTitle}
          </h2>
          <div className="text-[8px] lg:text-xs leading-relaxed text-gray-300 flex flex-col gap-2">
            <p>{t.secFameIntro}</p>
            <div className="flex flex-col gap-2 mt-1">
              <div className="pixel-card bg-black/30 p-3 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <span className="text-yellow-400 text-[10px] lg:text-sm font-bold">#1</span>
                  <div>
                    <span className="text-white text-[9px] lg:text-sm font-bold">ozzy</span>
                    <span className="text-gray-500 text-[8px] lg:text-[9px] ml-2">Feb 2026</span>
                  </div>
                </div>
                <span className="text-[8px] lg:text-[9px] text-red-400 font-bold uppercase px-2 py-0.5 bg-red-900/40 pixel-border">
                  Broken Access Control
                </span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};
